<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div class="btnnowrap" style="margin-top: 2px">
                    <el-button type="primary" size="mini" @click="batchBalance" :disabled="!btn.batchbalance">{{
                        $t('getapi[5078]') }}
                    </el-button>
                    <el-button type="primary" size="mini" @click="batchNoBalance" :disabled="!btn.batchrbalance">{{
                        $t('getapi[5079]') }}</el-button>
                    <el-button type="primary" size="mini" @click="beforeUpdateUserStatus" :disabled="!btn.cmuuser">{{$t('getapi[7221]')}}</el-button>
                    <el-button type="primary" size="mini" @click="beforeBatchAudit" :disabled="!btn.batchaudit || !btn.audit">{{
                        $t('getapi[1315]') }}</el-button>
                </div>
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="IssInvoiceListViewInfo"
                        :filter_language="['balancemode_name','invoice_status','virtual_flag','img','invoice_usestatus']"
                        :filter_thousandth_puramount="['remain_amount','vender_remain_amount','diff_amount']"
                        :filter_date="['invoice_date','payment_date']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        ref="singleTable"
                ></wTable>
                <!--<el-table
                        :data="dataSet"
                        ref="singleTable"
                        v-loading="loading"
                        :highlight-current-row="true"
                        show-overflow-tooltip="true"
                        border
                        stripe
                        size="mini"
                        :height="tableHeight - reduceTableHeight"
                        header-row-class-name="headerclass"
                        @row-click="editInfo"
                        @row-dblclick="openEdit"
                        @selection-change="handleSelectionChange"
                        style="width: 100%; margin-top:0px"
                >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_year" :label="$t('getapi[3677]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_year" :label="$t('getapi[3679]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_month" :label="$t('getapi[3680]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_month" :label="$t('getapi[3678]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_no" :label="$t('getapi[2992]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_code" :label="$t('getapi[3681]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_type_name" :label="$t('getapi[3682]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_date" :label="$t('getapi[3683]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="balancemode_name" :label="$t('getapi[1228]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1196]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_name" :label="$t('getapi[3685]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="payment_date" :label="$t('getapi[3686]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="currency_code" :label="$t('getapi[3108]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="exchange_rate" :label="$t('getapi[3287]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="remain_amount" :label="$t('getapi[3688]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="vender_remain_amount" :label="$t('getapi[3689]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[3690]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="create_date" :label="$t('getapi[3691]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[4043]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_date" :label="$t('getapi[3692]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="payment_period" :label="$t('getapi[1600]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="tax_code" :label="$t('getapi[3693]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="tax_rate" :label="$t('getapi[1225]')" align="right"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_status" :label="$t('getapi[3694]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="exchange_modify_person" :label="$t('getapi[3695]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="exchange_modify_date" :label="$t('getapi[3696]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="audit_period" :label="$t('getapi[3697]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="diff_amount" :label="$t('getapi[3735]')" align="right" width="110"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="virtual_flag" :label="$t('getapi[3700]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="img" :label="$t('getapi[6391]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoicenumlst" :label="$t('getapi[7222]')"></el-table-column>
                    <el-table-column show-overflow-tooltip prop="invoice_usestatus" :label="$t('getapi[7223]')"></el-table-column>
                </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div>
                        <div class="btnnowrap">
                            <el-button type="primary" size="mini" @click="batchImport" :disabled="!btn.batchImport || addoredit != 0">{{
                                $t('getapi[412]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeAuditIssInvoice" :disabled="!btn.audit || addoredit == 0">{{
                                $t('getapi[3607]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="rAuditIssInvoice" :disabled="!btn.raudit">{{
                                $t('getapi[1334]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="balanceIssInvoice" :disabled="!btn.balance">{{
                                $t('getapi[1868]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="rBalanceIssInvoice" :disabled="!btn.rbalance">{{
                                $t('getapi[1869]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetRateIssInvoice" :disabled="!btn.setrate">{{
                                $t('getapi[3878]') }}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetTaxRateIssInvoice" :disabled="!btn.settaxrate">
                                {{$t('getapi[7224]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeSetChangeTaxRateIssInvoice" :disabled="!btn.settaxrateback">{{$t('getapi[7225]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="checkPurInBill">{{$t('getapi[7256]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeChangeAuditDate" :disabled="!btn.editauditdate">{{$t('getapi[3722]')}}
                            </el-button>
                            <el-button type="primary" size="mini" @click="beforeChangePayDate" :disabled="!btn.fkrq">{{$t('getapi[7226]')}}
                            </el-button>
                            <br/><br/>
                            <el-radio v-model="billmode" label="1" style="margin-left: 8px">{{$t('getapi[3978]')}}</el-radio>
                            <el-radio v-model="billmode" label="2">{{$t('getapi[3979]')}}</el-radio>
                        </div>
                        <div style="width:880px;min-width:880px">
                            <table>
                                <tr>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[2992]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.invoice_no"  class="mcolor" v-show="dataDetail.Head.invoice_status == 0 && addoredit == 0"
                                        ></el-input>
                                        <el-input type="text" size="mini" v-model="dataDetail.Head.invoice_no" :readonly="true" class="readO" v-show="dataDetail.Head.invoice_status != 0 || addoredit != 0"></el-input>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3682]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-select filterable v-model="dataDetail.Head.invoice_type_code" size="mini">
                                            <el-option v-for="item in invoiceType" :key="item.Code" :label="item.Name"
                                                       :value="item.Code" :disabled="dataDetail.Head.invoice_status != 0"></el-option>
                                        </el-select>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3686]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-date-picker v-model="dataDetail.Head.payment_date" type="date" size="mini"
                                                        style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                    </td>
                                    <td style="width:60px;min-width:60px">{{ $t('getapi[3694]') }}</td>
                                    <td style="width:160px;min-width:160px">
                                        <el-input  type="text" size="mini" :value="expInvoiceStatus(dataDetail.Head.invoice_status)" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[3681]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.invoice_code" :readonly="dataDetail.Head.invoice_status != 0" :class="{'readO':dataDetail.Head.invoice_status != 0}"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3683]') }}</td>
                                    <td>
                                        <el-date-picker v-model="dataDetail.Head.invoice_date" type="date" size="mini"
                                                        style="width:100%" :readonly="dataDetail.Head.invoice_status != 0" :class="{'readO':dataDetail.Head.invoice_status != 0}"></el-date-picker>
                                    </td>
                                    <td>{{ $t('getapi[3287]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.exchange_rate" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3748]') }}</td>
                                    <td>
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :value="dataDetail.Head.total_amount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[1196]') }}</td>
                                    <td>
                                        <routejump :urlNo="26" v-show="dataDetail.Head.invoice_status == 0">
                                        <el-input  type="text" v-model="dataDetail.Head.vender_code"
                                                   readonly
                                                   class="mcolor"
                                                   size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectSupplier()"></i>
                                        </el-input>
                                        </routejump>
                                        <el-input v-model="dataDetail.Head.vender_code" size="mini"  v-show="dataDetail.Head.invoice_status != 0" :readonly="true" class="readO"></el-input>
                                    </td>
                                    <td>{{ $t('getapi[1197]') }}</td>
                                    <td colspan="3">
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.vender_name" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td>{{ $t('getapi[3704]') }}</td>
                                    <td>
                                        <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" v-model="dataDetail.Head.tax_total_amount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[3697]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" v-model="dataDetail.Head.audit_period" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td></td>
                                    <td></td>
                                    <td>{{ $t('getapi[3747]') }}</td>
                                    <td>
                                        <el-input  type="text" size="mini" :value="dataDetail.Head.diffamount" :readonly="true" class="readO"
                                        ></el-input>
                                    </td>
                                    <td></td>
                                    <td colspan="2">
                                        <el-checkbox v-model="dataDetail.Head.virtual_flag" :true-label=1 :false-label=0 :disabled="dataDetail.Head.invoice_status != 0"></el-checkbox>
                                        {{ $t('getapi[3700]') }}
                                    </td>
                                </tr>
                                <tr>
                                    <td>{{ $t('getapi[7222]') }}</td>
                                    <td colspan="9">
                                        <el-input v-model="dataDetail.Head.invoicenumlst" type="textarea" size="mini"></el-input>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                    <el-tabs :tab-position="'top'" type="" style="margin-top: 0px" @tab-click="selectInfo">
                        <el-tab-pane :label="$t('getapi[3726]')" name="0">
                            <div class="btnnowrap">
                                <el-button type="primary" size="mini" @click="showAddOrder('')" :disabled="!btn.batchadd">{{ $t('getapi[878]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchdel">{{
                                    $t('getapi[1522]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-0"
                                    :data="dataDetail.Lists"
                                    @selection-change="handleSelectionChangeDetail"
                                    :row-class-name="tableRowClassNameDetail"
                                    :highlight-current-row="true"
                                    :height="tableHeight - 300"
                                    header-row-class-name="headerclass"
                                    border
                                    size="mini"
                                    style="width: 100%; margin-top:3px"
                                    ref="singleTable1"
                            >
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="ipo_code" :label="$t('getapi[4283]')" width="120"></el-table-column>
                                <el-table-column prop="receive_order_no" :label="$t('getapi[463]')" width="150">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input
                                                v-model="scope.row.receive_order_no"
                                                type="text"
                                                readonly
                                                class="mcolor"
                                                size="mini"
                                        >
                                            <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddOrder(scope)"></i>
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="schedule_no" :label="$t('getapi[4209]')" width="100"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="receive_order_line_no" :label="$t('getapi[2239]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[4364]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[116]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_model" :label="$t('getapi[124]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="part_spec" :label="$t('getapi[125]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="releaseinvoiceqty" :label="$t('getapi[2004]')" align="right"></el-table-column>
                                <el-table-column prop="invoice_qty" :label="$t('getapi[1628]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.invoice_qty" @change="changeDataDetailData(scope,1)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="measure_unit" :label="$t('getapi[888]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="vender_net_unit_price" :label="$t('getapi[2009]')" align="right" width="110"></el-table-column>
                                <el-table-column prop="vender_line_net_total_amount" :label="$t('getapi[2010]')" align="right" width="110">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number"  autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.vender_line_net_total_amount" @change="changeDataDetailData(scope,2)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="net_unit_price" :label="$t('getapi[2007]')" align="right" width="110"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_net_total_amount" :label="$t('getapi[2008]')" align="right" width="110"></el-table-column>
                                <el-table-column prop="tax_amount" :label="$t('getapi[3732]')" align="right">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.tax_amount" @change="changeDataDetailData(scope,3)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_total_amount" :label="$t('getapi[3733]')" align="right"></el-table-column>
                                <el-table-column prop="line_remark" :label="$t('getapi[4279]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" v-model="scope.row.line_remark"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="order_net_amount" :label="$t('getapi[3003]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_net_amount_diff" :label="$t('getapi[3735]')" width="110"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[3739]')" name="1">
                            <table :height="tableHeight - 280">
                                <table>
                                    <tr>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1228]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-select filterable v-model="dataDetail.Head.balance_mode" size="mini">
                                                <el-option v-for="item in balanceMode" :key="item.Code" :label="item.Name"
                                                           :value="item.Code"></el-option>
                                            </el-select>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1221]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.payment_period" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1249]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.tax_code" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td style="width:60px;min-width:60px">{{ $t('getapi[1225]') }}</td>
                                        <td style="width:120px;min-width:120px">
                                            <el-input v-model="dataDetail.Head.tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[3740]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetail.Head.currency_code" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1219]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetail.Head.bank_account_name" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                        <td>{{ $t('getapi[1220]') }}</td>
                                        <td colspan="3">
                                            <el-input v-model="dataDetail.Head.bank_account_number" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>{{ $t('getapi[1224]') }}</td>
                                        <td>
                                            <el-input v-model="dataDetail.Head.tax_number" size="mini" :readonly="true" class="readO"></el-input>
                                        </td>
                                    </tr>
                                </table>
                            </table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[3741]')" name="2">
                            <div>
                                <el-button type="primary" size="mini" @click="addOtherCostList" :disabled="!btn.batchaddcost">{{ $t('getapi[6708]') }}
                                </el-button>
                                <el-button type="primary" size="mini" @click="batchDelOtherCostList" :disabled="!btn.batchdelcost">{{
                                    $t('getapi[4097]') }}
                                </el-button>
                            </div>
                            <el-table
                                    id="xdetilpane-1"
                                    :data="dataDetail.OtherCostList"
                                      :highlight-current-row="true"
                                      show-overflow-tooltip="true"
                                      :height="tableHeight - 300"
                                      header-row-class-name="headerclass"
                                      @selection-change="handleSelectionChangeDetailCost"
                                      :row-class-name="tableRowClassNameDetailCost" border stripe
                                      size="mini" style="width: 100%;margin-top:3px"
                                      ref="singleTable2">
                                <el-table-column type="selection"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="line_no" :label="$t('getapi[1425]')"></el-table-column>
                                <el-table-column prop="charge_name" :label="$t('getapi[2728]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" v-model="scope.row.charge_name"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="charge_qty" :label="$t('getapi[3101]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.charge_qty" @change="changechargedata(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="net_unit_price" :label="$t('getapi[3714]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.net_unit_price" @change="changechargedata(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="unit_price" :label="$t('getapi[3806]')">
                                    <template scope="scope" v-if="dataDetail.Head.invoice_status == 0">
                                        <el-input size="mini" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.unit_price" @change="changechargedata(scope)"></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="net_total_amount" :label="$t('getapi[2010]')">
                                    <template scope="scope">
                                        <span style="color: red;">{{scope.row.net_total_amount}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="total_amount"   :label="$t('getapi[2012]')">
                                    <template scope="scope">
                                        <span style="color: red;">{{scope.row.total_amount}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_net_unit_price" :label="$t('getapi[2007]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_unit_price" :label="$t('getapi[3744]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_net_total_amount" :label="$t('getapi[2008]')"></el-table-column>
                                <el-table-column show-overflow-tooltip prop="base_total_amount" :label="$t('getapi[3745]')"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                        <el-tab-pane :label="$t('getapi[7227]')" name="3">
                            <table :height="tableHeight - 280" v-if="!showpdf">
                                <div style="height:100%;overflow-y: auto" class="demo-image__lazy">
                                    <el-image v-for="data in dataDetail.ImgList" :key="data.invoice_no" :src="data.HttpFilePath">

                                    </el-image>
                                </div>
                                <!--<div style="display: flex">
                                    <el-upload
                                            list-type="picture-card"
                                            action=""
                                            :file-list="fileList">
                                        <i slot="default" class="el-icon-plus"></i>
                                        <div slot="file" slot-scope="{file}">
                                            <img
                                                    class="el-upload-list__item-thumbnail"
                                                    :src="file.url" alt=""
                                            >
                                            <span class="el-upload-list__item-actions">
                                            <span
                                                    class="el-upload-list__item-preview"
                                                    @click="handlePictureCardPreview(file)"
                                            >
                                              <i class="el-icon-zoom-in"></i>
                                            </span>
                                            <span
                                                    v-if="!disabled"
                                                    class="el-upload-list__item-delete"
                                                    @click="handleRemove(file)"
                                            >
                                              <i class="el-icon-delete"></i>
                                            </span>
                                          </span>
                                        </div>
                                    </el-upload>
                                    <el-dialog v-dialogDrag :visible.sync="dialogVisible">
                                        <img width="100%" :src="dialogImageUrl" alt="">
                                    </el-dialog>
                                </div>-->
                            </table>
                            <div :height="tableHeight - 280" class="pdf" v-if="showpdf">
                                <iframe v-bind:src="src" width="100%" :height="tableHeight - 280"></iframe>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                    <div style="width:720px;min-width:720px">
                        <table>
                            <tr>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[1890]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetail.Head.create_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[4043]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetail.Head.audit_person" size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:100px;min-width:100px">{{ $t('getapi[3749]') }}</td>
                                <td style="width:140px;min-width:140px">
                                    <el-input v-model="dataDetail.Head.net_total_amount " type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1859]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.create_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[3692]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.audit_date" type="date" size="mini"
                                                    style="width:100%" :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[3746]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.vender_net_total_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>

        <el-dialog v-dialogDrag :visible.sync="visUpdateUserStatus" :title="$t('getapi[7223]')" width="25%" :close-on-click-modal="false" >
            <el-input v-model="userStatus" type="textarea"></el-input>
            <span slot="footer" class="dialog-footer">
				<el-button @click="visUpdateUserStatus = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button type="primary" @click="updateUserStatus">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="auditCheckVisiable" width="25%" :close-on-click-modal="false" >
            {{$t('getapi[7232]')}}
            <el-date-picker
                    v-model="auditCheckData.YearMonth"
                    :start-placeholder="auditCheckData.DBYM"
                    :end-placeholder="auditCheckData.SysYM"
                    :picker-options="pickerOptionsInterval"
                    type="month"
                    >
            </el-date-picker>
            <el-input :value="$t('getapi[7233]') + auditCheckData.DBYM + $t('getapi[7234]') + auditCheckData.SysYM" type="textarea" style="margin-top: 8px"></el-input>

            <span slot="footer" class="dialog-footer">
				<el-button @click="auditCheckFalse">{{$t('getapi[2053]')}}</el-button>
				<el-button type="primary" @click="auditCheckTrue">{{$t('getapi[2052]')}}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visRate" :title="$t('getapi[3878]')" width="15%" :close-on-click-modal="false" >
            <tr><td>{{$t('getapi[3287]')}}</td><td><el-input v-model="exchange_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td></tr>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="setRateIssInvoice">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visTaxRate" :title="$t('getapi[7224]')" width="15%" :close-on-click-modal="false" >
            <tr><td>税率</td><td><el-input v-model="tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td></tr>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visTaxRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="setTaxRateIssInvoice">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangeAuditDate" :title="$t('getapi[7235]')" width="15%" :close-on-click-modal="false" >
            <div style="display: flex;">
                <el-date-picker
                        v-model="audit_period">
                </el-date-picker>
                <el-button size="mini" type="primary" @click="changeAuditDate">{{$t('getapi[2092]')}}</el-button>
            </div>
            <div style="height:10px"></div>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangePayDate" :title="$t('getapi[7236]')" width="15%" :close-on-click-modal="false" >
            <span>采购发票：{{dataDetail.Head.invoice_no}}</span>
            <div style="display: flex;margin-top: 15px">
                <el-date-picker
                        v-model="payDate">
                </el-date-picker>
                <el-button size="mini" type="primary" @click="changePayDate">{{$t('getapi[2092]')}}</el-button>
            </div>
            <div style="height:10px"></div>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="visChangeTaxRate" :title="$t('getapi[7237]')" width="15%" :close-on-click-modal="false" >
            <div style="text-align: center">
            <span style="color:red">{{$t('getapi[7238]')}}</span>
            <br/>
            <span style="color:red">{{$t('getapi[7239]')}}</span>
            </div>
            <tr><td>{{$t('getapi[7240]')}}</td><td><el-input v-model="old_tax_rate" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini"></el-input></td>%</tr>

            <span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="visChangeTaxRate = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="mini" type="primary" @click="setChangeTaxRateIssInvoice">{{ $t('getapi[1146]') }}</el-button>
			</span>
        </el-dialog>

        <serce :isVisible="isVisible" queryData="IssInvoiceListViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6605]')" queryData="IssInvoiceListViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择供应商-->
        <selector :isVisible="false" :isBatch=false :isSplitPage=true :postUrl="'/Iss/Invoice/GetIssInvoiceSupplyList'" @callback="getsupplier" ref="supplier"></selector>
        <!--发票明细- 整单模式-->
        <selectorvxe :isVisible="false" :isBatch=true :postUrl="'/Iss/Invoice/GetIssRecInListByVendCode'" @callback="getorder" ref="order"></selectorvxe>
        <selector :isVisible="false" :isBatch=false :isSplitPage=false :postUrl="'/Iss/Invoice/GetIssRecInListByVendCode'" @callback="getorder" ref="ordersingle"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import { Loading } from 'element-ui'
    export default {
        name:'3_issinvoiceview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_issinvoiceview'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                RightSelectIndex: '0',
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight3,
                dataDetail: {
                    Head: {},
                    Lists: [],
                    OtherCostList: [],
                    ImgList:[]
                },
                oldDataDetail: '',
                code: '', // 当前选择行代码（唯一）
                selectCodeData: [], //主表勾选invoice_no合集
                selectData:[],
                selectDataDetail:[],
                selectDataDetailRed: [],
                selectDataDetailCost:[],
                invoiceType: [],
                invoiceOrderType: [],
                balanceMode:[],
                billmode: '1', // 选择器模式 ：整单模式 1 、行模式 2
                oneormore: 1,
                rowindex: -1,
                oneormorered: 1,
                rowindexred: -1,
                dataDetailLineNo: 1, // 行号
                dataDetailLineNoCost: 1,
                dataDetailLineNoRed: 1,
                auditCheckData: {
                    YearMonth:null,
                    Message:null,
                    DBYM:"",
                    SysYM:"",
                    Result:false
                },
                beforeEventName: '',// 校验审核期间后执行的方法名称
                visRate: false,
                visTaxRate: false,
                visChangeTaxRate: false,
                visChangeAuditDate: false,
                visUpdateUserStatus: false,
                auditCheckVisiable: false,
                userStatus: '',
                old_tax_rate: '',
                exchange_rate: '',
                tax_rate: '',
                audit_period: '',
                btn: {
                    batchaudit: false,
                    batchbalance: false,
                    batchrbalance: false,
                    cmuuser: false,
                    batchImport: false,
                    audit: false,
                    raudit: false,
                    balance: false,
                    rbalance: false,
                    setrate: false,
                    settaxrate: false,
                    settaxrateback: false,
                    editauditdate: false,
                    batchadd: false,
                    batchdel: false,
                    batchaddcost: false,
                    batchdelcost: false,
                    fkrq: false
                },
                addoredit: 0, // 0:新增2：修改
                pickerOptionsInterval: {
                    disabledDate: this.disabledDate
                },
                visChangePayDate: false,
                payDate: '',
                fileList: [], //发票图片
                dialogImageUrl: '',
                dialogVisible: false,
                disabled: false,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                //pdf文件显示
                src: '', // pdf文件地址
                showpdf: false,//发票图片是否显示pdf
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            'dataDetail.Lists': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            },
            'dataDetail.OtherCostList': function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(this.RightSelectIndex)
                })
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('3_issinvoiceview', that)
            that.userData = sessionStorage.getItem('userData');
            that.invoiceType = Array.methods.getInvoiceType();
            that.invoiceOrderType = Array.methods.getInvoiceOrderType();
            that.balanceMode = Array.methods.getBalanceMode();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd()
            that.authority();
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'issrelation' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('IssInvoiceListViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            tableRowClassNameDetail({row, rowIndex}){
                row.index = rowIndex;
            },
            tableRowClassNameDetailCost({row, rowIndex}){
                row.index = rowIndex;
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6605]"),this.$t("getapi[3836]"));
            },
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                console.log('权限' + that.$limits.authority('plv2', 230, 1))
                if(!this.$limits.menuvisible("plv2", 231, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 230, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 231, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 231, 1) == 2) {
                        if (that.$limits.authority('plv3', 231,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 231,1) == 1) {
                            //编辑级
                            if(!that.$limits.fnIsEmpty(that.dataDetail.Head.invoice_no)){
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('save,search,refresh,export');
                            }
                        }
                        if (that.$limits.authority('plv3', 231, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.invoice_no)) {
                                if(that.dataDetail.Head.invoice_status > 0){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.batchaudit = false;
                //批量审核
                if (that.$limits.authority('plv4', 114, 1) == 1) {
                    if(that.selectData.length > 0 ){
                        that.btn.batchaudit = that.selectData.every(val => {
                            return val.invoice_status == '生成'
                        });
                        console.log(that.btn.batchaudit)
                        /*that.btn.batchaudit = true;*/
                    } else {
                        that.btn.batchaudit = false;
                    }
                }
                // 批量记账
                that.btn.batchbalance = false
                if (that.$limits.authority('plv4', 196, 1) == 1) {
                    if(that.selectData.length > 0 ){
                        that.btn.batchbalance = that.selectData.every(val => {
                            return val.invoice_status == '审核'
                        });
                        /*that.btn.batchbalance = true;*/
                    } else {
                        that.btn.batchbalance = false;
                    }
                }
                // 批量反记账
                that.btn.batchrbalance = false
                if (that.$limits.authority('plv4', 197, 1) == 1) {
                    if(that.selectData.length > 0 ){
                        that.btn.batchrbalance = that.selectData.every(val => {
                            return val.invoice_status == '记账'
                        });
                        /*that.btn.batchrbalance = true;*/
                    } else {
                        that.btn.batchrbalance = false;
                    }
                }
                that.btn.cmuuser = false;
                //更新发票使用状态
                if (that.$limits.authority('plv4', 110, 1) == 1) {
                    if(that.selectData.length == 1){
                        that.btn.cmuuser = true;
                    }
                }
                that.btn.batchImport = false
                that.btn.audit = false
                that.btn.raudit = false
                that.btn.balance = false
                that.btn.rbalance = false
                that.btn.setrate = false
                that.btn.settaxrate = false
                that.btn.settaxrateback = false
                that.btn.editauditdate = false
                that.btn.batchadd = false
                that.btn.batchdel = false
                that.btn.batchaddcost = false
                that.btn.batchdelcost = false
                if(that.dataDetail.Head.invoice_status == 0){ // 生成
                    that.btn.batchImport = true
                    that.btn.audit = true
                    that.btn.setrate = true
                    that.btn.settaxrate = true
                    that.btn.settaxrateback = true
                    that.btn.batchadd = true
                    that.btn.batchaddcost = true
                    if(that.selectDataDetail.length > 0 ){
                        that.btn.batchdel = true
                    }
                    if(that.selectDataDetailCost.length > 0){
                        that.btn.batchdelcost = true
                    }
                }
                if(that.dataDetail.Head.invoice_status == 1){ // 审核
                    that.btn.raudit = true
                    that.btn.balance = true
                    that.btn.editauditdate = true
                }
                if(that.dataDetail.Head.invoice_status == 3){ // 记账
                    that.btn.rbalance = true
                    that.btn.editauditdate = true
                }
                if(that.dataDetail.Head.invoice_status == 4){
                    that.btn.editauditdate = false
                }
                if(that.btn.audit == true){
                    that.btn.audit = that.$limits.authority('plv4', 194, 1) == 1? true: false
                }
                if(that.btn.raudit == true){
                    that.btn.raudit = that.$limits.authority('plv4', 195, 1) == 1? true: false
                }
                if(that.btn.balance == true){
                    that.btn.balance = that.$limits.authority('plv4', 196, 1) == 1? true: false
                }
                if(that.btn.rbalance == true){
                    that.btn.rbalance = that.$limits.authority('plv4', 197, 1) == 1? true: false
                }
                if(that.btn.batchImport == true){
                    that.btn.batchImport = that.$limits.authority('plv4', 266, 1) == 1? true: false
                }
                if(that.btn.setrate == true){
                    that.btn.setrate = that.$limits.authority('plv4', 271, 1) == 1? true: false
                }
                if(that.btn.settaxrate == true){
                    that.btn.settaxrate = that.$limits.authority('plv4', 271, 1) == 1? true: false
                }
                if(that.btn.settaxrateback == true){
                    that.btn.settaxrateback = that.$limits.authority('plv4', 271, 1) == 1? true: false
                }
                if(that.btn.editauditdate == true){
                    that.btn.editauditdate = that.$limits.authority('plv4', 194, 1) == 1? true: false
                }
                that.btn.fkrq = that.btn.editauditdate
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_issinvoiceview',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'IssInvoiceListViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Iss/Invoice/IssInvDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if(that.addoredit == 0){
                    that.add()
                } else {
                    that.getDetail(that.code)
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                for(let i = 0;i<datacopy.OtherCostList.length;i++){
                    delete datacopy.OtherCostList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit == 0){
                                that.getView();
                                that.confirmAdd()
                            } else {
                                that.getView();
                                that.getDetail(that.code)
                            }
                        });
                } else {
                    if(that.addoredit == 0){
                        that.getView();
                        that.confirmAdd()
                    } else {
                        that.getView();
                        that.getDetail(that.code)
                    }
                }
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$confirm('是导出图片吗？', that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[2052]'),
                    cancelButtonText: that.$t('getapi[2053]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                        that.$http.urlpost('/Iss/Invoice/IssInvExportToHtml', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                            if (res.Success == 1) {
                                let hrefurl = Common.Url + res.DataContent.URL;
                                window.open(hrefurl);
                            }
                        });
                    })
                    .catch(() => {
                        /*that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                        that.$http.urlpost('/Iss/Invoice/IssInvExportToExecl', parm, function(res) {
                            that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                            if (res.Success == 1) {
                                let hrefurl = Common.Url + res.DataContent.URL;
                                window.open(hrefurl);
                            }
                        });*/
                        let param = {
                            query_sign: "IssInvoiceListViewInfo",
                            fromname: that.$t('getapi[6605]'),
                            SelectIndex: 0,
                            MultyVer: that.$processdata.getLanguage(),
                            Param: datac
                        };
                        that.$processdata.commonExport(param)
                    });
            },
            // 新增
            add(){
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                for(let i = 0;i<datacopy.OtherCostList.length;i++){
                    delete datacopy.OtherCostList[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this
                let date = Common.methods.getDate()
                that.billmode = '1'
                that.addoredit = 0
                that.code = ''
                that.dataDetail.Head = {
                    invoice_no: '',
                    invoice_code: '',
                    invoice_type_code: '',
                    invoice_date: date,
                    balance_mode: '',
                    payment_period: 0,
                    tax_code: '',
                    tax_rate: 0,
                    vender_code: '',
                    payment_date: '',
                    currency_code: '',
                    exchange_rate: 0,
                    exchange_modify_person: '',
                    exchange_modify_date: '',
                    audit_period: '',
                    hook_period: '',
                    create_person: '',
                    create_date: '',
                    audit_person: '',
                    audit_date: '',
                    hookrelation_person: '',
                    hookrelation_date: '',
                    net_total_amount: 0,
                    vender_net_total_amount: 0,
                    total_amount: 0,
                    invoice_status: 0,
                    vender_remain_amount: 0,
                    remain_amount: 0,
                    tax_total_amount: 0,
                    remark: '',
                    virtual_flag: 0,
                    concurrent_time: 0,
                    invoicenumlst: '',
                    bank_account_name: '',
                    bank_account_number: '',
                    tax_number: '',
                    vender_name: '',
                    diffamount: '',
                    isadd: 1
                }
                that.dataDetail.Lists = []
                that.dataDetail.OtherCostList = []
                that.dataDetail.ImgList=[]
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.btnauthority()
            },
            save(){
                let that = this
                let parm = {
                    Head: that.dataDetail.Head,
                    Lists: that.dataDetail.Lists,
                    OtherCostList: that.dataDetail.OtherCostList,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Iss/Invoice/SaveData', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.code = res.UniqueNum
                        that.getDetail(res.UniqueNum)
                    }
                });
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[4532]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
				.then(() => {  
                    let parm = {
                        invoice_no: that.dataDetail.Head.invoice_no,
                        concurrent_time: that.dataDetail.Head.concurrent_time
                    }
                    that.$http.urlpost('/Iss/Invoice/DelIssInvBill', parm, function(res) {
                        if (res.Success == 1) {
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                            that.getView()
                            that.confirmAdd()
                        }
                    });
                })
				.catch(() => {
					this.$message({
						type: 'info',
						message: that.$t('getapi[8574]')
					});
				});    
            },
            editInfo(row){
                let that = this
                if(that.code == row.invoice_no){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 231, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                    }
                    for(let i = 0;i<datacopy.OtherCostList.length;i++){
                        delete datacopy.OtherCostList[i]['index']
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.code = row.invoice_no
                                that.getDetail(row.invoice_no)
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow)
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.code = row.invoice_no
                        that.getDetail(row.invoice_no)
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.addoredit = 1
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Iss/Invoice/GetIssInvoiceBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.dataDetail.Head.isadd = 0
                        if(that.dataDetail.ImgList.length == 1){
                            let str = that.dataDetail.ImgList[0].HttpFilePath
                            if(str.slice(str.length - 3,str.length).toLowerCase()=='pdf'){
                                that.src = str
                                that.showpdf = true
                            } else {
                                that.showpdf = false
                                that.fileList = [...that.fileList,{
                                    invoice_no: that.dataDetail.ImgList[0].invoice_no,
                                    wxserviceid: that.dataDetail.ImgList[0].wxserviceid,
                                    name: '',
                                    url: that.dataDetail.ImgList[0].HttpFilePath
                                }]
                            }
                        } else if(that.dataDetail.ImgList.length > 1){
                            that.showpdf = false
                            that.fileList = []
                            for(let i = 0 ;i<that.dataDetail.ImgList.length;i++){
                                that.fileList = [...that.fileList,{
                                    invoice_no: that.dataDetail.ImgList[i].invoice_no,
                                    wxserviceid: that.dataDetail.ImgList[i].wxserviceid,
                                    name: '',
                                    url: that.dataDetail.ImgList[i].HttpFilePath
                                }]
                            }
                        } else {
                            that.showpdf = false
                            that.fileList = []
                        }
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.authority();
                        that.btnauthority()
                    }
                    loadingInstance.close()
                });
            },
            handleSelectionChange(val){
                let that = this
                that.selectCodeData = []
                that.selectData = []
                for(let i = 0;i<val.length;i++){
                    that.selectCodeData.push(val[i].invoice_no)
                    that.selectData.push(val[i])
                }
                that.btnauthority();
            },
            // 勾选发票明细
            handleSelectionChangeDetail(val){
                let that = this
                that.selectDataDetail = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataDetail.push(val[i])
                }
                that.btnauthority()
            },
            // 勾选发票明细 - 红字
            handleSelectionChangeDetailRed(val){
                let that = this
                that.selectDataDetailRed = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataDetailRed.push(val[i])
                }
                that.btnauthority()
            },
            // 勾选费用明细
            handleSelectionChangeDetailCost(val){
                let that = this
                that.selectDataDetailCost = []
                for(let i = 0;i<val.length;i++){
                    that.selectDataDetailCost.push(val[i])
                }
                that.btnauthority()
            },
            //批量记账
            batchBalance(){
                let that = this
                if(that.selectCodeData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        invoice_no: that.selectData[i].invoice_no
                    }]
                }
                let parm = {
                    List: arr
                }
                that.$http.urlpost('/Iss/Invoice/IssInvBatchBalance', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            //批量反记账
            batchNoBalance(){
                let that = this
                if(that.selectCodeData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        invoice_no: that.selectData[i].invoice_no
                    }]
                }
                let parm = {
                    List: arr
                }
                that.$http.urlpost('/Iss/Invoice/IssInvBatchNoBalance', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            beforeUpdateUserStatus(){
                let that = this
                that.userStatus = that.selectData[0].invoice_usestatus
                that.visUpdateUserStatus = true
            },
            // 更行发票使用状态
            updateUserStatus(){
                let that = this
                console.log(that.selectData)
                let parm = {
                    invoice_no: that.selectData[0].invoice_no,
                    UseStatus: that.userStatus
                }
                that.$http.urlpost('/Iss/Invoice/IssInvoiceUpdateUserStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visUpdateUserStatus = false
                        that.getView()
                    }
                });
            },
            beforeBatchAudit(){
              let that = this
                that.beforeEventName = 'batchAudit'
                that.checkAuditTime()
            },
            // 批量审核
            batchAudit(){
                let that = this
                if(that.selectCodeData.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        invoice_no: that.selectData[i].invoice_no
                    }]
                }
                let parm = {
                    List: arr,
                    YearMonth: that.auditCheckData.YearMonth
                }
                that.$http.urlpost('/Iss/Invoice/IssInvBatchAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getView()
                    }
                });
            },
            expInvoiceStatus(val){
                let that = this
                if(val == 0){
                    return that.$t('getapi[1422]')//'生成'
                } else if(val == 1){
                    return that.$t('getapi[941]')//'审核'
                } else if(val == 2){
                    return that.$t('getapi[8921]')//'钩稽'
                } else if(val == 3){
                    return that.$t('getapi[1868]')//'记账'
                } else if(val == 4){
                    return that.$t('getapi[3754]')//'月结'
                } else if(val == 5){
                    return that.$t('getapi[3755]')//'作废'
                } else {
                    return ''
                }
            },
            // 新增单据
            showAddOrder(row) {
                let that = this;
                if(that.dataDetail.Head.vender_code == '' || that.dataDetail.Head.vender_code == null){
                    that.$message.warning(that.$t('getapi[8896]'));//'供应商不能为空'
                    return
                }
                if (row == '') {
                    that.oneormore = 1;
                    let  param =  {
                        billmode: that.billmode,
                        vender_code: that.dataDetail.Head.vender_code
                    }
                    that.$refs.order.clearInput(true, param);
                } else {
                    that.oneormore = 2;
                    that.rowindex = row.$index;
                    let  param =  {
                        billmode: that.billmode,
                        vender_code: that.dataDetail.Head.vender_code
                    }
                    that.$refs.ordersingle.clearInput(true, param);
                }
            },
            getorder(data){
                let that = this
                console.log(data)
                if(that.billmode == 1){
                    let orderArr = []
                    if(data.length > 0){
                        for(let i = 0;i<data.length;i++){
                            orderArr = [...orderArr, {relation_order_no: data[i].order_no}]
                        }
                    } else {
                        orderArr.push(data)
                    }
                    let parm = {
                        vender_code: that.dataDetail.Head.vender_code,
                        exchange_rate: that.dataDetail.Head.exchange_rate,
                        tax_rate: that.dataDetail.Head.tax_rate,
                        Lists: orderArr
                    }
                    let loadingInstance = Loading.service(Common.maskoption1);
                    that.$http.urlpost('/Iss/Invoice/GetIssRecInListByOrderNo', parm, function (res) {
                        if (res.Success == 1) {
                            let resData = res.DataContent.Lists
                            that.dataDetailLineNo = 1
                            if(that.oneormore == 1) {
                                for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                                    if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                                        that.dataDetailLineNo = that.dataDetail.Lists[i].line_no + 1
                                    }
                                }
                                for(let i = 0; i < resData.length;i++){
                                    that.dataDetail.Lists = [...that.dataDetail.Lists, {
                                        relation_invoice_no: resData[i].relation_invoice_no,
                                        line_no:that.dataDetailLineNo++,
                                        receive_order_no:resData[i].receive_order_no,
                                        receive_order_line_no:resData[i].receive_order_line_no,
                                        order_flag: resData[i].order_flag,
                                        part_code:resData[i].part_code,
                                        part_version:resData[i].part_version,
                                        routing_id:resData[i].routing_id,
                                        workproc_name:resData[i].workproc_name,
                                        part_name:resData[i].part_name,
                                        part_model:resData[i].part_model,
                                        part_spec:resData[i].part_spec,
                                        measure_unit:resData[i].measure_unit,
                                        invoice_qty:resData[i].invoice_qty,
                                        net_unit_price:resData[i].net_unit_price,
                                        line_net_total_amount:resData[i].line_net_total_amount,
                                        tax_amount:resData[i].tax_amount,
                                        old_tax_amount:resData[i].old_tax_amount,
                                        line_total_amount:resData[i].line_total_amount,
                                        vender_net_unit_price:resData[i].vender_net_unit_price,
                                        vender_line_net_total_amount:resData[i].vender_line_net_total_amount,
                                        old_vender_line_net_total_amount:resData[i].old_vender_line_net_total_amount,
                                        base_net_amount_diff:resData[i].base_net_amount_diff,
                                        vender_net_amount_diff:resData[i].vender_net_amount_diff,
                                        line_remark:resData[i].line_remark,
                                        ipo_line_id:resData[i].ipo_line_id,
                                        ipo_code:resData[i].ipo_code,
                                        releaseinvoiceqty:resData[i].releaseinvoiceqty,
                                        order_net_amount:resData[i].order_net_amount,
                                        schedule_no:resData[i].schedule_no,
                                    }]
                                }
                            } else {
                                that.dataDetail.Lists[that.rowindex].relation_invoice_no='',
                                that.dataDetail.Lists[that.rowindex].relation_invoice_no=resData[0].relation_invoice_no,
                                that.dataDetail.Lists[that.rowindex].receive_order_no=resData[0].receive_order_no,
                                that.dataDetail.Lists[that.rowindex].receive_order_line_no=resData[0].receive_order_line_no,
                                that.dataDetail.Lists[that.rowindex].order_flag=resData[0].order_flag,
                                that.dataDetail.Lists[that.rowindex].part_code=resData[0].part_code,
                                that.dataDetail.Lists[that.rowindex].part_version=resData[0].part_version,
                                that.dataDetail.Lists[that.rowindex].routing_id=resData[0].routing_id,
                                that.dataDetail.Lists[that.rowindex].workproc_name=resData[0].workproc_name,
                                that.dataDetail.Lists[that.rowindex].part_name=resData[0].part_name,
                                that.dataDetail.Lists[that.rowindex].part_model=resData[0].part_model,
                                that.dataDetail.Lists[that.rowindex].part_spec=resData[0].part_spec,
                                that.dataDetail.Lists[that.rowindex].measure_unit=resData[0].measure_unit,
                                that.dataDetail.Lists[that.rowindex].invoice_qty=resData[0].invoice_qty,
                                that.dataDetail.Lists[that.rowindex].net_unit_price=resData[0].net_unit_price,
                                that.dataDetail.Lists[that.rowindex].line_net_total_amount=resData[0].line_net_total_amount,
                                that.dataDetail.Lists[that.rowindex].tax_amount=resData[0].tax_amount,
                                that.dataDetail.Lists[that.rowindex].old_tax_amount=resData[0].old_tax_amount,
                                that.dataDetail.Lists[that.rowindex].line_total_amount=resData[0].line_total_amount,
                                that.dataDetail.Lists[that.rowindex].vender_net_unit_price=resData[0].vender_net_unit_price,
                                that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount=resData[0].vender_line_net_total_amount,
                                that.dataDetail.Lists[that.rowindex].old_vender_line_net_total_amount=resData[0].old_vender_line_net_total_amount,
                                that.dataDetail.Lists[that.rowindex].base_net_amount_diff=resData[0].base_net_amount_diff,
                                that.dataDetail.Lists[that.rowindex].vender_net_amount_diff=resData[0].vender_net_amount_diff,
                                that.dataDetail.Lists[that.rowindex].line_remark=resData[0].line_remark,
                                that.dataDetail.Lists[that.rowindex].ipo_line_id=resData[0].ipo_line_id,
                                that.dataDetail.Lists[that.rowindex].ipo_code=resData[0].ipo_code,
                                that.dataDetail.Lists[that.rowindex].releaseinvoiceqty=resData[0].releaseinvoiceqty,
                                that.dataDetail.Lists[that.rowindex].order_net_amount=resData[0].order_net_amount,
                                that.dataDetail.Lists[that.rowindex].schedule_no=resData[0].schedule_no
                                
                            }
                        }
                        loadingInstance.close()
                    });
                } else {
                    if(that.oneormore == 1) {
                        let newindex = that.dataDetail.Lists.length
                        that.dataDetailLineNo = 1
                        for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                            if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                                that.dataDetailLineNo = that.dataDetail.Lists[i].line_no + 1
                            }
                        }
                        for(let i = 0; i < data.length;i++){
                            that.dataDetail.Lists = [...that.dataDetail.Lists, {
                                relation_invoice_no: '',
                                line_no:that.dataDetailLineNo++,
                                receive_order_no:data[i].relation_order_no,
                                receive_order_line_no:data[i].line_no,
                                order_flag: '',
                                part_code:data[i].part_code,
                                part_version:data[i].part_version,
                                routing_id:'',
                                workproc_name:data[i].workproc_name,
                                part_name:data[i].part_name,
                                part_model:data[i].part_model,
                                part_spec:data[i].part_spec,
                                measure_unit:data[i].inv_unit,
                                invoice_qty:data[i].invoice_qty,
                                net_unit_price:'',
                                line_net_total_amount:'',
                                tax_amount:'',
                                old_tax_amount:'',
                                line_total_amount:'',
                                vender_net_unit_price:'',
                                vender_line_net_total_amount:'',
                                old_vender_line_net_total_amount:'',
                                base_net_amount_diff:'',
                                vender_net_amount_diff:'',
                                line_remark:'',
                                ipo_line_id:data[i].ipo_line_id,
                                ipo_code:data[i].ipo_code,
                                releaseinvoiceqty:data[i].releaseinvoiceqty,
                                order_net_amount:'',
                                line_net_unitprice: data[i].line_net_unitprice,
                                schedule_no:data[i].schedule_no
                            }]
                            for(let i = newindex;i<that.dataDetail.Lists.length;i++){
                                that.dataDetail.Lists[i].net_unit_price = that.dataDetail.Lists[i].line_net_unitprice * parseFloat(that.dataDetail.Head.exchange_rate)
                                that.dataDetail.Lists[i].vender_net_unit_price = that.dataDetail.Lists[i].net_unit_price
                                that.dataDetail.Lists[i].vender_line_net_total_amount = Math.round(parseFloat(that.dataDetail.Lists[i].net_unit_price) * parseFloat(that.dataDetail.Lists[i].invoice_qty) * 100)/100
                                that.dataDetail.Lists[i].line_net_total_amount = that.dataDetail.Lists[i].vender_line_net_total_amount * parseFloat(that.dataDetail.Head.exchange_rate)
                                that.dataDetail.Lists[i].tax_amount = Math.round(that.dataDetail.Lists[i].line_net_total_amount * that.dataDetail.Head.tax_rate / 100 * 100)/100
                                that.dataDetail.Lists[i].line_total_amount = Math.round((parseFloat(that.dataDetail.Lists[i].line_net_total_amount) + parseFloat(that.dataDetail.Lists[i].tax_amount))* 100) / 100
                            }
                        }
                    } else {
                        that.dataDetail.Lists[that.rowindex].relation_invoice_no='',
                        that.dataDetail.Lists[that.rowindex].receive_order_no=data.relation_order_no,
                        that.dataDetail.Lists[that.rowindex].receive_order_line_no=data.line_no,
                        that.dataDetail.Lists[that.rowindex].order_flag='',
                        that.dataDetail.Lists[that.rowindex].part_code=data.part_code,
                        that.dataDetail.Lists[that.rowindex].part_version=data.part_version,
                        that.dataDetail.Lists[that.rowindex].routing_id='',
                        that.dataDetail.Lists[that.rowindex].workproc_name=data.workproc_name,
                        that.dataDetail.Lists[that.rowindex].part_name=data.part_name,
                        that.dataDetail.Lists[that.rowindex].part_model=data.part_model,
                        that.dataDetail.Lists[that.rowindex].part_spec=data.part_spec,
                        that.dataDetail.Lists[that.rowindex].measure_unit=data.inv_unit,
                        that.dataDetail.Lists[that.rowindex].invoice_qty=data.invoice_qty,
                        that.dataDetail.Lists[that.rowindex].net_unit_price=data.line_net_unitprice,
                        that.dataDetail.Lists[that.rowindex].line_net_total_amount='',
                        that.dataDetail.Lists[that.rowindex].tax_amount='',
                        that.dataDetail.Lists[that.rowindex].old_tax_amount='',
                        that.dataDetail.Lists[that.rowindex].line_total_amount='',
                        that.dataDetail.Lists[that.rowindex].vender_net_unit_price='',
                        that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount='',
                        that.dataDetail.Lists[that.rowindex].old_vender_line_net_total_amount='',
                        that.dataDetail.Lists[that.rowindex].base_net_amount_diff='',
                        that.dataDetail.Lists[that.rowindex].vender_net_amount_diff='',
                        that.dataDetail.Lists[that.rowindex].line_remark='',
                        that.dataDetail.Lists[that.rowindex].ipo_line_id=data.ipo_line_id,
                        that.dataDetail.Lists[that.rowindex].ipo_code=data.ipo_code,
                        that.dataDetail.Lists[that.rowindex].releaseinvoiceqty=data.releaseinvoiceqty,
                        that.dataDetail.Lists[that.rowindex].order_net_amount='',
                        that.dataDetail.Lists[that.rowindex].line_net_unitprice = data.line_net_unitprice,
                        that.dataDetail.Lists[that.rowindex].net_unit_price = that.dataDetail.Lists[that.rowindex].line_net_unitprice * parseFloat(that.dataDetail.Head.exchange_rate),
                        that.dataDetail.Lists[that.rowindex].vender_net_unit_price = that.dataDetail.Lists[that.rowindex].net_unit_price,
                        that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount = Math.round(parseFloat(that.dataDetail.Lists[that.rowindex].net_unit_price) * parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty) * 100)/100,
                        that.dataDetail.Lists[that.rowindex].line_net_total_amount = that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount * parseFloat(that.dataDetail.Head.exchange_rate),
                        that.dataDetail.Lists[that.rowindex].tax_amount = Math.round(that.dataDetail.Lists[that.rowindex].line_net_total_amount * that.dataDetail.Head.tax_rate / 100 * 100)/100,
                        that.dataDetail.Lists[that.rowindex].line_total_amount = Math.round((parseFloat(that.dataDetail.Lists[that.rowindex].line_net_total_amount) + parseFloat(that.dataDetail.Lists[that.rowindex].tax_amount))* 100) / 100,
                        that.dataDetail.Lists[that.rowindex].schedule_no=data.schedule_no
                    }
                }
            },
            changeDataDetailData(row,type){
                let that = this
                that.rowindex = row.$index
                let token = JSON.parse(that.userData).token;
                if(type == 1){
                    let Net_Unit_Price = parseFloat(that.dataDetail.Lists[that.rowindex].net_unit_price)
                    let Invoice_qty = that.dataDetail.Lists[that.rowindex].invoice_qty
                    let Vender_Line_Net_Total_Amount = parseFloat(that.dataDetail.Lists[that.rowindex].vender_net_unit_price) * Invoice_qty
                    that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount = that.$processdata.mathRound2(Vender_Line_Net_Total_Amount)
                    let Line_Net_Total_Amount = that.$processdata.mathRound2(Net_Unit_Price * Invoice_qty)
                    that.dataDetail.Lists[that.rowindex].line_net_total_amount = that.$processdata.mathRound2(Line_Net_Total_Amount)
                    let Tax_Amount = Net_Unit_Price * (parseFloat(that.dataDetail.Head.tax_rate) / 100) * Invoice_qty
                    that.dataDetail.Lists[that.rowindex].tax_amount = that.$processdata.mathRound2(Tax_Amount)
                    let Vender_Net_Unit_Price = parseFloat(that.dataDetail.Lists[that.rowindex].vender_net_unit_price)
                    let Line_Total_Amount = Line_Net_Total_Amount + Tax_Amount
                    that.dataDetail.Lists[that.rowindex].line_total_amount = that.$processdata.mathRound2(Line_Total_Amount)
                    let tprice;
                    let TTotal;
                    let data = {
                        receive_order_no: that.dataDetail.Lists[that.rowindex].receive_order_no,
                        receive_order_line_no: that.dataDetail.Lists[that.rowindex].receive_order_line_no
                    }
                    $.ajax({
                        url: Common.Url + '/Iss/Invoice/GetIssOrderPrice?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                tprice = res.DataContent
                            }
                        }
                    });
                    TTotal = parseFloat(that.$processdata.mathRound2(parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty)) * tprice * parseFloat(that.dataDetail.Head.exchange_rate))
                    that.dataDetail.Lists[that.rowindex].base_net_amount_diff = that.$processdata.mathRound2(that.$processdata.mathRound2(that.dataDetail.Lists[that.rowindex].line_net_total_amount) - that.$processdata.mathRound2(TTotal))
                } else if(type == 2){
                    that.dataDetail.Lists[that.rowindex].vender_net_unit_price = that.$processdata.mathRound6(parseFloat(that.dataDetail.Lists[that.rowindex].vender_line_net_total_amount) / parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty))
                    that.dataDetail.Lists[that.rowindex].net_unit_price = that.dataDetail.Lists[that.rowindex].vender_net_unit_price * parseFloat(that.dataDetail.Head.exchange_rate)
                    that.dataDetail.Lists[that.rowindex].line_net_total_amount = Math.round(that.dataDetail.Lists[that.rowindex].net_unit_price * parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty) * 100)/100
                    that.dataDetail.Lists[that.rowindex].tax_amount = Math.round(that.dataDetail.Lists[that.rowindex].net_unit_price * parseFloat(that.dataDetail.Head.tax_rate / 100) * that.dataDetail.Lists[that.rowindex].invoice_qty * 100)/100
                    that.dataDetail.Lists[that.rowindex].line_total_amount = that.$processdata.numberAdd((that.dataDetail.Lists[that.rowindex].line_net_total_amount * 100) / 100 , (that.dataDetail.Lists[that.rowindex].tax_amount * 100) / 100)
                    let tprice;
                    let TTotal;
                    let data = {
                        receive_order_no: that.dataDetail.Lists[that.rowindex].receive_order_no,
                        receive_order_line_no: that.dataDetail.Lists[that.rowindex].receive_order_line_no
                    }
                    $.ajax({
                        url: Common.Url + '/Iss/Invoice/GetIssOrderPrice?token=' + token,
                        type: 'post',
                        async: false,
                        data: JSON.stringify(data),
                        contentType: 'application/json',
                        success: function (res) {
                            if (res.Success == 1) {
                                tprice = res.DataContent
                            }
                        }
                    });
                    TTotal = parseFloat(that.$processdata.mathRound2(parseFloat(that.dataDetail.Lists[that.rowindex].invoice_qty)) * tprice * parseFloat(that.dataDetail.Head.exchange_rate))
                    that.dataDetail.Lists[that.rowindex].base_net_amount_diff = that.$processdata.mathRound2(that.$processdata.mathRound2(that.dataDetail.Lists[that.rowindex].line_net_total_amount) - that.$processdata.mathRound2(TTotal))
                } else if (type == 3){
                    that.dataDetail.Lists[that.rowindex].line_total_amount =that.NumberAdd( that.dataDetail.Lists[that.rowindex].line_net_total_amount  , that.dataDetail.Lists[that.rowindex].tax_amount )
                }
            },
            NumberAdd (arg1, arg2) {//浮点数加法
                var r1, r2, m, n;
                try {
                    r1 = arg1.toString().split(".")[1].length
                } catch (e) {
                    r1 = 0
                }
                try {
                    r2 = arg2.toString().split(".")[1].length
                } catch (e) {
                    r2 = 0
                }
                m = Math.pow(10, Math.max(r1, r2))
                n = (r1 >= r2) ? r1 : r2;
                return ((arg1 * m + arg2 * m) / m).toFixed(n);
            },
            batchDel(){
                let that = this;               

                let msginfo;
                if (that.billmode == 1) {
                    // 整单模式
                    msginfo = that.$t('getapi[12560]')//'此外协入库单的所有行将被删除，是否执行？';
                } else {
                    msginfo = that.$t('getapi[3821]')//'确认要删除选择的行吗？';
                }

                this.$confirm(msginfo, that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: that.dataDetail.Head.invoice_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            billmode: that.billmode,
                            virtual_flag:that.dataDetail.Head.virtual_flag,
                            Lists: [],
                            LangType: that.$processdata.getLang(),
                        };
                       
                        if(that.billmode == 1){
                            /*let data = that.dataDetail.Lists.filter(item => {
                                return that.selectDataDetail.every(item2 => {
                                    return item.receive_order_no == item2.receive_order_no
                                });
                            });
                            if(data.length > 0){
                                for (let i = data.length - 1; i >= 0; i--) {
                                    that.dataDetail.Lists.splice(data[i].index, 1);
                                    if(data[i].relation_invoice_no!="" && null != data[i].relation_invoice_no){
                                        let datatmp = {
                                            receive_order_no:data[i].receive_order_no,
                                            line_no: data[i].line_no,
                                        }
                                        parm.Lists.push(datatmp);
                                    }
                                }
                            }*/
                            for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
                                let receive_order_no = that.selectDataDetail[i].receive_order_no;
                                for (let j = that.dataDetail.Lists.length - 1; j >= 0; j--) {
                                    if (that.dataDetail.Lists[j].receive_order_no != receive_order_no) {
                                        continue;
                                    }

                                    if (that.dataDetail.Lists[j].relation_invoice_no != '' && null != that.dataDetail.Lists[j].relation_invoice_no) {
                                        parm.Lists.push({
                                            receive_order_no:that.dataDetail.Lists[j].receive_order_no,
                                            line_no: that.dataDetail.Lists[j].line_no,
                                        });
                                    }
                                    that.dataDetail.Lists.splice(j, 1);
                                }
                            }

                        } else {
                            for (let i = that.selectDataDetail.length - 1; i >= 0; i--) {
                                that.dataDetail.Lists.splice(that.selectDataDetail[i].index, 1);
                                if(that.selectDataDetail[i].relation_invoice_no!="" && null != that.selectDataDetail[i].relation_invoice_no){
                                    let datatmp = {
                                        receive_order_no:that.selectDataDetail[i].receive_order_no,
                                        line_no: that.selectDataDetail[i].line_no,
                                    }
                                    parm.Lists.push(datatmp);
                                }
                            }
                        }
                        if(that.dataDetail.Lists.length == 0 && that.addoredit != 0){
                            that.$confirm(that.$t('getapi[8605]'), that.$t('getapi[194]'), {//入库单都已删除，是否要删除发票主体
                                confirmButtonText: that.$t('getapi[1146]'),
                                cancelButtonText: that.$t('getapi[2054]'),
                                type: 'warning'
                            })
                                .then(() => {
                                    that.del()
                                })
                                .catch(() => {
                                    if(parm.Lists.length>0){
                                        that.$http.urlpost('/Iss/Invoice/DelIssInvLines', parm, function (res) {
                                            if (res.Success == 1) {
                                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                                that.getDetail(that.code)
                                            } else {
                                                that.getDetail(that.code)
                                            }
                                        });
                                    }
                                });
                        } else {
                            if(parm.Lists.length>0){
                                that.$http.urlpost('/Iss/Invoice/DelIssInvLines', parm, function (res) {
                                    if (res.Success == 1) {
                                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                        that.getDetail(that.code)
                                    } else {
                                        that.getDetail(that.code)
                                    }
                                });
                            }
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取采购订单
            selectSupplier() {
                let that = this;
                if(that.dataDetail.Lists.length>0){
                    that.$message.warning(that.$t('getapi[13146]'));
                    return;
                }
                that.$refs.supplier.clearInput(true);
            },
            // 获取订单信息
            getsupplier(data) {
                let that = this;
                console.log(data)
                let balancemode_name = data.balancemode_name
                for(let i=0;i<that.balanceMode.length;i++){
                    if(that.balanceMode[i].Name == balancemode_name){
                        that.dataDetail.Head.balance_mode = that.balanceMode[i].Code
                    }
                }
                that.dataDetail.Head.vender_code = data.vender_code
                that.dataDetail.Head.vender_name = data.vender_name
                let parm = {
                    Code: that.dataDetail.Head.vender_code
                }
                that.$http.urlpost('/Iss/Invoice/GetSupplyFinanceInfo', parm, function (res) {
                    if (res.Success == 1) {
                        let resData = res.DataContent.DataList[0]
                        that.dataDetail.Head.payment_period = resData.checkout_cycle
                        that.dataDetail.Head.tax_code = resData.tax_code
                        that.dataDetail.Head.tax_rate = resData.tax_rate
                        that.dataDetail.Head.currency_code = resData.currency_code
                        that.dataDetail.Head.bank_account_name = resData.bank_account_name
                        that.dataDetail.Head.bank_account_number = resData.bank_account_number
                        that.dataDetail.Head.tax_number = resData.tax_number
                        that.dataDetail.Head.exchange_rate = resData.exchange_rate
                    }
                });
            },
            // 新增费用明细行
            addOtherCostList(){
                let that = this
                that.dataDetailLineNoCost = 1
                for (let i = 0; i < that.dataDetail.OtherCostList.length; i++) {
                    if (that.dataDetail.OtherCostList[i].line_no >= that.dataDetailLineNoCost) {
                        that.dataDetailLineNoCost = that.dataDetail.OtherCostList[i].line_no + 1
                    }
                }
                that.dataDetail.OtherCostList = [...that.dataDetail.OtherCostList,{
                    relation_invoice_no: '',
                    line_no: that.dataDetailLineNoCost++,
                    charge_name: '',
                    net_unit_price: '',
                    unit_price: '',
                    net_total_amount: '',
                    total_amount: '',
                    charge_qty: '',
                    base_net_unit_price: '',
                    base_unit_price: '',
                    base_net_total_amount: '',
                    base_total_amount: ''
                }]
            },
            changechargedata(row){
                let that = this
                let index = row.$index
                if(that.dataDetail.OtherCostList[index].charge_qty == ''){
                    that.net_total_amount = 0
                    that.total_amount = 0
                    that.base_net_unit_price = 0
                    that.base_unit_price = 0
                    that.base_net_total_amount = 0
                    that.base_total_amount = 0
                }
                if(that.dataDetail.OtherCostList[index].charge_qty != '' && that.dataDetail.OtherCostList[index].net_unit_price != ''){
                    that.dataDetail.OtherCostList[index].net_total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].net_unit_price
                    that.dataDetail.OtherCostList[index].base_net_unit_price = that.dataDetail.OtherCostList[index].net_unit_price * that.dataDetail.Head.exchange_rate
                    that.dataDetail.OtherCostList[index].base_net_total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].base_net_unit_price
                }
                if(that.dataDetail.OtherCostList[index].charge_qty != '' && that.dataDetail.OtherCostList[index].unit_price != ''){
                    that.dataDetail.OtherCostList[index].total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].unit_price
                    that.dataDetail.OtherCostList[index].base_unit_price = that.dataDetail.OtherCostList[index].unit_price * that.dataDetail.Head.exchange_rate
                    that.dataDetail.OtherCostList[index].base_total_amount = that.dataDetail.OtherCostList[index].charge_qty * that.dataDetail.OtherCostList[index].base_unit_price
                }
                /*try{
                    let Net_Total_Amount = parseFloat(that.dataDetail.OtherCostList[index].charge_qty) * parseFloat(that.dataDetail.OtherCostList[index].net_unit_price)
                    that.dataDetail.OtherCostList[index].net_total_amount = that.$processdata.mathRound2(Net_Total_Amount)
                } catch{
                    that.dataDetail.OtherCostList[index].net_total_amount = 0
                }
                try{
                    let Total_Amount = parseFloat(that.dataDetail.OtherCostList[index].charge_qty) * parseFloat(that.dataDetail.OtherCostList[index].unit_price)
                    that.dataDetail.OtherCostList[index].total_amount = that.$processdata.mathRound2(Total_Amount)
                }catch{
                    that.dataDetail.OtherCostList[index].total_amount = 0
                }
                try{
                    that.dataDetail.OtherCostList[index].base_net_unit_price = parseFloat(that.dataDetail.OtherCostList[index].net_unit_price) * parseFloat(that.dataDetail.Head.exchange_rate)
                }catch{
                    that.dataDetail.OtherCostList[index].base_net_unit_price = 0
                }
                try{
                    that.dataDetail.OtherCostList[index].base_unit_price = parseFloat(that.dataDetail.OtherCostList[index].unit_price) * parseFloat(that.dataDetail.Head.exchange_rate)
                }catch{
                    that.dataDetail.OtherCostList[index].base_unit_price = 0
                }
                try{
                    let Base_Net_Total_Amount = parseFloat(that.dataDetail.OtherCostList[index].charge_qty) * parseFloat(that.dataDetail.OtherCostList[index].base_net_unit_price)
                    that.dataDetail.OtherCostList[index].base_net_total_amount = that.$processdata.mathRound2(Base_Net_Total_Amount)
                }catch{
                    that.dataDetail.OtherCostList[index].base_net_total_amount = 0
                }
                try{
                    let Base_Total_Amount = parseFloat(that.dataDetail.OtherCostList[index].charge_qty) * parseFloat(that.dataDetail.OtherCostList[index].base_unit_price)
                    that.dataDetail.OtherCostList[index].base_total_amount = that.$processdata.mathRound2(Base_Total_Amount)
                }catch{
                    that.dataDetail.OtherCostList[index].base_total_amount = 0
                }*/
            },
            batchDelOtherCostList(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: that.dataDetail.Head.invoice_no,
                            concurrent_time: that.dataDetail.Head.concurrent_time,
                            Lists: []
                        };
                        for (let i = that.selectDataDetailCost.length - 1; i >= 0; i--) {
                            that.dataDetail.OtherCostList.splice(that.selectDataDetailCost[i].index, 1);
                            if(that.selectDataDetailCost[i].relation_invoice_no !=""){
                                let datatmp = {
                                    line_no: that.selectDataDetailCost[i].line_no,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        if(parm.Lists.length>0){
                            that.$http.urlpost('/Iss/Invoice/DelIssInvOtherCostLines', parm, function (res) {
                                if (res.Success == 1) {
                                    that.getDetail(that.code);
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                }
                            });
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            checkAuditTime(){
                let that = this
                let parm = {
                }
                that.$http.urlpost('/Finance/Invoice/CheckAuditTime', parm, function (res) {
                    if (res.Success == 1) {
                        that.auditCheckData = res.DataContent
                        that.auditIssInvoice();
                    } else if(res.Success == 2){
                        that.auditCheckData = res.DataContent
                        that.auditCheckData.YearMonth = that.auditCheckData.SysYM
                        that.auditCheckVisiable = true
                    }
                });
            },
            auditCheckFalse(){
                let that = this
                that.auditCheckData.YearMonth = that.auditCheckData.DBYM
                that.auditCheckVisiable = false
                if(that.beforeEventName == 'auditIssInvoice'){
                    that.auditIssInvoice()
                } else if(that.beforeEventName == 'batchAudit'){
                    that.batchAudit()
                }
            },
            auditCheckTrue(){
                let that = this
                that.auditCheckVisiable = false
                if(that.beforeEventName == 'auditIssInvoice'){
                    that.auditIssInvoice()
                } else if(that.beforeEventName == 'batchAudit'){
                    that.batchAudit()
                }
            },
            batchImport(){
              let that = this
              let parm = {
                  vender_code: that.dataDetail.Head.vender_code,
                  exchange_rate: that.dataDetail.Head.exchange_rate,
                  tax_rate: that.dataDetail.Head.tax_rate
              }
                that.$http.urlpost('/Iss/Invoice/BatchInIssInv', parm, function (res) {
                    if (res.Success == 1) {
                        let resData = res.DataContent.Lists
                        that.dataDetailLineNo = 1
                        if (that.oneormore == 1) {
                            for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                                if (that.dataDetail.Lists[i].line_no >= that.dataDetailLineNo) {
                                    that.dataDetailLineNo = that.dataDetail.Lists[i].line_no + 1
                                }
                            }
                            for (let i = 0; i < resData.length; i++) {
                                that.dataDetail.Lists = [...that.dataDetail.Lists, {
                                    relation_invoice_no: resData[i].relation_invoice_no,
                                    line_no: that.dataDetailLineNo++,
                                    receive_order_no: resData[i].receive_order_no,
                                    receive_order_line_no: resData[i].receive_order_line_no,
                                    order_flag: resData[i].order_flag,
                                    part_code: resData[i].part_code,
                                    part_version: resData[i].part_version,
                                    routing_id: resData[i].routing_id,
                                    workproc_name: resData[i].workproc_name,
                                    part_name: resData[i].part_name,
                                    part_model: resData[i].part_model,
                                    part_spec: resData[i].part_spec,
                                    measure_unit: resData[i].measure_unit,
                                    invoice_qty: resData[i].invoice_qty,
                                    net_unit_price: resData[i].net_unit_price,
                                    line_net_total_amount: resData[i].line_net_total_amount,
                                    tax_amount: resData[i].tax_amount,
                                    old_tax_amount: resData[i].old_tax_amount,
                                    line_total_amount: resData[i].line_total_amount,
                                    vender_net_unit_price: resData[i].vender_net_unit_price,
                                    vender_line_net_total_amount: resData[i].vender_line_net_total_amount,
                                    old_vender_line_net_total_amount: resData[i].old_vender_line_net_total_amount,
                                    base_net_amount_diff: resData[i].base_net_amount_diff,
                                    vender_net_amount_diff: resData[i].vender_net_amount_diff,
                                    line_remark: resData[i].line_remark,
                                    ipo_line_id: resData[i].ipo_line_id,
                                    ipo_code: resData[i].ipo_code,
                                    releaseinvoiceqty: resData[i].releaseinvoiceqty,
                                    order_net_amount: resData[i].order_net_amount
                                }]
                            }
                        }
                    }
                });
            },
            beforeAuditIssInvoice(){
                let that = this
                that.beforeEventName = 'auditIssInvoice'
                that.checkAuditTime()
            },
            // 审核
            auditIssInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    yearmonth: that.auditCheckData.YearMonth,
                    create_date: that.dataDetail.Head.create_date,
                    invoice_date: that.dataDetail.Head.invoice_date,
                    tax_rate: that.dataDetail.Head.tax_rate,
                    virtual_flag:that.dataDetail.Head.virtual_flag,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Iss/Invoice/AuditIssInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 反审核
            rAuditIssInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    yearmonth: that.dataDetail.Head.audit_period,
                    create_date: that.dataDetail.Head.create_date,
                    invoice_date: that.dataDetail.Head.invoice_date,
                    tax_rate: that.dataDetail.Head.tax_rate,
                    LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Iss/Invoice/RAuditIssInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 记账
            balanceIssInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                }
                that.$http.urlpost('/Iss/Invoice/BalanceIssInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            // 反记账
            rBalanceIssInvoice(){
                let that = this
                let parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                }
                that.$http.urlpost('/Iss/Invoice/RBalanceIssInvoice', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.getDetail(that.code)
                    }
                });
            },
            beforeSetRateIssInvoice(){
                let that = this
                that.visRate = true
                that.exchange_rate = that.dataDetail.Head.exchange_rate
            },
            // 变更汇率
            setRateIssInvoice(){
                let that = this
                let parm = {}
                parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    exchange_rate:  that.exchange_rate,
                    tax_rate: that.dataDetail.Head.tax_rate,
                    frmflg: 2
                }
                that.$http.urlpost('/Finance/Invoice/SetRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visRate = false
                        that.getDetail(that.code)
                    }
                });
            },
            beforeSetTaxRateIssInvoice(){
                let that = this
                that.visTaxRate = true
                that.tax_rate = that.dataDetail.Head.tax_rate
            },
            // 变更税率
            setTaxRateIssInvoice(){
                let that = this
                let parm = {}
                parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    order_type: 'iss',
                    tax_rate: that.tax_rate,
                }
                that.$http.urlpost('/Finance/Invoice/SetTaxRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visTaxRate = false
                        that.getDetail(that.code)
                    }
                });
            },
            beforeSetChangeTaxRateIssInvoice(){
                let that = this
                that.visChangeTaxRate = true
            },
            // 变更含税税率
            setChangeTaxRateIssInvoice(){
                let that = this
                let parm = {}
                parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    order_type: 'iss',
                    old_tax_rate: that.old_tax_rate,
                    tax_rate: that.dataDetail.Head.tax_rate,
                    exchange_rate: that.dataDetail.Head.exchange_rate,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                }
                that.$http.urlpost('/Finance/Invoice/ChanageSetTaxRate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visChangeTaxRate = false
                        that.getDetail(that.code)
                    }
                });
            },
            checkPurInBill(){
                let that = this
                let arr = []
                for(let i = 0;i<that.dataDetail.Lists.length;i++){
                    arr = [...arr,{
                        receive_order_no: that.dataDetail.Lists[i].receive_order_no,
                        receive_order_line_no: that.dataDetail.Lists[i].receive_order_line_no
                    }]
                }
                let parm = {
                  invoice_no:that.dataDetail.Head.invoice_no,
                  concurrent_time: that.dataDetail.Head.concurrent_time,
                  List: arr,
                  LangType: that.$processdata.getLang(),
                }
                that.$http.urlpost('/Iss/Invoice/CheckPurInBill', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                    }
                });
            },
            beforeChangeAuditDate(){
                let that = this
                that.visChangeAuditDate = true
                let date = new Date(that.dataDetail.Head.audit_period);
                let currentMonth = date.getMonth();
                let nextMonth = ++currentMonth;
                let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1);
                let oneDay = 1000 * 60 * 60 * 24;
                let lastTime = new Date(nextMonthFirstDay - oneDay);
                let day = lastTime.getDate();
                that.audit_period = that.dataDetail.Head.audit_period + '-' + day
            },
            changeAuditDate(){
                let that = this
                let parm = {}
                parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    audit_period: that.dataDetail.Head.audit_period,
                    concurrent_time: that.dataDetail.Head.concurrent_time,
                    auditdate: that.audit_period,
                    billtype: 1
                }
                that.$http.urlpost('/Finance/Invoice/ChanageAuditDate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visChangeAuditDate = false
                        that.getDetail(that.code)
                    }
                });
            },
            beforeChangePayDate(){
                let that = this
                that.visChangePayDate = true
                that.payDate = (that.dataDetail.Head.payment_date == '' ? Common.methods.getDate() : that.dataDetail.Head.payment_date)
            },
            changePayDate(){
                let that = this
                let parm = {}
                parm = {
                    invoice_no: that.dataDetail.Head.invoice_no,
                    paydate: that.payDate,
                    billtype: 1
                }
                that.$http.urlpost('/Finance/Invoice/ChanagePayMentDate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.visChangePayDate = false
                        that.getDetail(that.code)
                    }
                });
            },
            // 审核区间约束
            disabledDate(time){
                let that = this
                let starttime = new Date(that.auditCheckData.DBYM).getTime()
                let endtime = new Date(that.auditCheckData.SysYM).getTime()
                return time.getTime() < starttime || time.getTime() > endtime
            },
            //删除照片
            handleRemove(file){
                let that = this
                console.log(file)
                this.$confirm(that.$t('getapi[8897]'), that.$t('getapi[194]'), {//'确定删除图片?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            invoice_no: file.invoice_no,
                            wxserviceid: file.wxserviceid,
                        }
                        that.$http.urlpost('/Finance/Invoice/DelInvoicePic', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                                that.getDetail(that.code)
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            selectInfo(tab, event) {
                let that = this;
                that.RightSelectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initFormRight(that.RightSelectIndex)
                });
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 231,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                }
                for(let i = 0;i<datacopy.OtherCostList.length;i++){
                    delete datacopy.OtherCostList[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.el-upload--picture-card{
        display: none;
    }
</style>
